const EXTERIOR_COLOR = 'exterior_color';
const INTERIOR_COLOR = 'interior_color';

/**
 * Checks if the category name is of a color filter.
 *
 * @param categoryName filter category name
 * @returns True if the category name is a color filter, false otherwise.
 */
export default function isColorFilter(categoryName: string): boolean {
  return categoryName === EXTERIOR_COLOR || categoryName === INTERIOR_COLOR;
}
